import { render, staticRenderFns } from "./PostcodeArgs.vue?vue&type=template&id=1b8c080a&scoped=true&"
import script from "./PostcodeArgs.vue?vue&type=script&lang=ts&"
export * from "./PostcodeArgs.vue?vue&type=script&lang=ts&"
import style0 from "./PostcodeArgs.vue?vue&type=style&index=0&id=1b8c080a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8c080a",
  null
  
)

export default component.exports